import { render, staticRenderFns } from "./MenuVideos.vue?vue&type=template&id=5be5e1f8&scoped=true&"
import script from "./MenuVideos.vue?vue&type=script&lang=js&"
export * from "./MenuVideos.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=5be5e1f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be5e1f8",
  null
  
)

export default component.exports